import React from 'react';
import ReactDOM from 'react-dom';

import { createHashHistory } from 'History';

import { Router, Route, useRouterHistory } from 'react-router'

import { syncHistoryWithStore, RouterStore } from 'mobx-react-router';

import { Provider } from 'mobx-react';

import Hrm from 'weaHrmEngine' //umd

const routing = new RouterStore();

const allStore = {
  routing,
  ...Hrm.store,
}

const HrmRoute = Hrm.Route;

const browserHistory = useRouterHistory(createHashHistory)({
  queryKey: '_key',
  basename: '/'
});

const history = syncHistoryWithStore(browserHistory, allStore.routing);

const Home = props => props.children;

const Root = () => (
  <Provider ecId={`${this && this.props && this.props.ecId || ''}_Provider@4whlgz`} {...allStore}>
    <Router ecId={`${this && this.props && this.props.ecId || ''}_Router@kf3xss`} history={history}>
      <Route ecId={`${this && this.props && this.props.ecId || ''}_Route@jx91vi`} name="main" breadcrumbName="入口" path="" component={Home}>
        { HrmRoute }
      </Route>
    </Router>
  </Provider>
);

ReactDOM.render(<Root ecId={`${this && this.props && this.props.ecId || ''}_Root@wzjvgy`}/>, document.getElementById('container'));


// WEBPACK FOOTER //
// ../src4js/pc4backstage/hrmengine/single.js